/**
 * Quill HTML class/attribute styles for read-only previews (A4 iframe, PDF shell).
 * Mirrors quill.snow.css rules not loaded inside the preview iframe.
 */
export const QUILL_PREVIEW_CONTENT_STYLES = `
  .document-content .ql-align-center {
    text-align: center;
  }

  .document-content .ql-align-right {
    text-align: right;
  }

  .document-content .ql-align-justify {
    text-align: justify;
  }

  .document-content .ql-direction-rtl {
    direction: rtl;
    text-align: inherit;
  }

  .document-content [dir='rtl'] {
    direction: rtl;
    text-align: inherit;
  }

  .document-content li.ql-direction-rtl,
  .document-content .ql-direction-rtl > li {
    padding-right: 1.5em;
    padding-left: 0;
  }

  .document-content .ql-direction-rtl ol,
  .document-content .ql-direction-rtl ul,
  .document-content ol.ql-direction-rtl,
  .document-content ul.ql-direction-rtl {
    padding-left: 0;
    padding-right: 1.5em;
  }

  .document-content .ql-indent-1:not(.ql-direction-rtl) {
    padding-left: 3em;
  }

  .document-content .ql-indent-2:not(.ql-direction-rtl) {
    padding-left: 6em;
  }

  .document-content .ql-indent-3:not(.ql-direction-rtl) {
    padding-left: 9em;
  }

  .document-content li.ql-indent-1.ql-direction-rtl {
    padding-right: 3em;
    padding-left: 0;
  }

  .document-content li.ql-indent-2.ql-direction-rtl {
    padding-right: 6em;
    padding-left: 0;
  }

  .document-content li.ql-indent-3.ql-direction-rtl {
    padding-right: 9em;
    padding-left: 0;
  }

  .document-content h1,
  .document-content h2,
  .document-content h3,
  .document-content h4,
  .document-content h5,
  .document-content h6 {
    margin: 0 0 4mm;
  }
`;
